import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from "./i18n/i18n";
import applySeo from "./seo";
import { themeState } from "./theme";
import Master from "./views/Master";
import Index from "./views/pages/Index";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '',
            redirect: '/en'
        }, {
            path: '/:lang',
            component: Master,
            children: [
                {
                    path: '',
                    name: 'Index',
                    component: Index,
                }
            ]
        }
    ]
});

let loading = null;
router.beforeResolve((to, from, next) => {
    if (to.name) {
        loading = router.app.$vs.loading({
            type: 'corners',
            background: themeState.theme === 'dark' ? '#0f1518' : '#cdd3e1',
            color: themeState.theme === 'dark' ? '#a9c8d6' : '#22333B'
        });
    }
    next();
});

router.beforeEach((to, from, next) => {
    const lang = to.params.lang;
    if (!["en", "fa"].includes(lang)) {
        i18n.locale = "en";
        return next("/en");
    }
    if (i18n.locale !== lang) {
        i18n.locale = lang;
    }
    applySeo(i18n.locale);
    next();
});

router.afterEach(() => {
    if (loading) {
        loading.close();
        loading = null;
    }
});

export default router;